<div class="ext-sports">
    <h1>Sportangebote</h1>
    <div class="ext-sports-list">
        <tsv-sport-card *ngFor="let sport of sports$ | async" [sport]="sport" [size]="'sm'"></tsv-sport-card>
    </div>
</div>